/****************************************************************
 * Js imports
 ****************************************************************/
/****************************************************************
 * CODE collapsible
 ****************************************************************/

!function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = 'collapsible';

  /**
   * @param $element Element Wrapping container div
   * @param options Options passed to public functions
   * @return collapsible_plugin
   */
  var collapsible_plugin = function collapsible_plugin($element, options) {
    // Scope it
    var self = this;
    self.$element = $element;

    // Set default options
    var defaults = {
      jsAnimation: false,
      // Open and close animation by JS, if false provide custom css to handle the .collapsible__is-open state
      openOnHover: false,
      // Open Parents on mouseOver and close on mouseLeave
      closeOnMouseleave: false,
      // Close all Parents when mouse leaves the Wrapper
      closeSiblings: false,
      // Close sibling Parents when opening a Parent - value must be a screen width! When >= screenwidth, Parents will close
      closeAll: false // Close all other Parents in wrapper when opening a Parent
    };

    // Get options from element data
    var dataOptions = self.$element.data('collapsible-wrapper');

    // Merge data options with default options
    self.options = $.extend({}, defaults, dataOptions);
    if ($.pp.debug) {
      console.log('Init collapsible:', self.$element, self.options);
    }

    // Start the collapsible
    self.init();
  };

  /**
   * Init
   *
   * @return void
   * @access public
   */
  collapsible_plugin.prototype.init = function () {
    var self = this;

    // Catch custom events on Parents [data-collapsible-parent] and on the element itself
    self.$element.on({
      'collapsibleOpen': function collapsibleOpen(event) {
        self.open($(event.target));
      },
      'collapsibleClose': function collapsibleClose(event) {
        self.close($(event.target));
      }
    }).on({
      'collapsibleOpen': function collapsibleOpen(event) {
        self.open($(event.target));
      },
      'collapsibleClose': function collapsibleClose(event) {
        self.close($(event.target));
      }
    }, '[data-collapsible-parent]');

    // Catch click on Triggers [data-collapsible-trigger]
    self.$element.on({
      click: function click(event) {
        event.stopPropagation();
        var $parent = $(this).closest('[data-collapsible-parent]');

        // If Parent is closed - open it
        if (!$parent.hasClass('collapsible__is-open')) {
          event.preventDefault();
          $parent.trigger('collapsibleOpen');
        } else {
          // Else if Parent is not a link, close it
          var $trigger = $(this);
          if (!$trigger.is('a')) {
            $parent.trigger('collapsibleClose');
          }
          // Else follow the link
        }
      }
    }, '[data-collapsible-trigger]').not('[data-collapsible-wrapper] [data-collapsible-trigger]');

    // Catch click on Trigger Icon [data-collapsible-trigger-icon]
    self.$element.on({
      click: function click(event) {
        event.stopPropagation();
        event.preventDefault();
        var $parent = $(this).closest('[data-collapsible-parent]');

        // If Parent is closed - open it
        if (!$parent.hasClass('collapsible__is-open')) {
          // Self.open( $parent );
          $parent.trigger('collapsibleOpen');
        } else {
          // Else close it
          $parent.trigger('collapsibleClose');
        }
        return false;
      }
    }, '[data-collapsible-trigger-icon]').not('[data-collapsible-wrapper] [data-collapsible-icon]');

    // Catch hover on [data-collapsible-parent]
    if (self.options.openOnHover) {
      self.$element.on({
        mouseenter: function mouseenter(event) {
          // No hover effects on touch devices
          if ($('html').hasClass('touch')) {
            return;
          }
          $(this).trigger('collapsibleOpen');
        },
        mouseleave: function mouseleave(event) {
          // No hover effects on touch devices
          if ($('html').hasClass('touch')) {
            return;
          }
          $(this).trigger('collapsibleClose');
        }
      }, '[data-collapsible-parent]').not('[data-collapsible-wrapper] [data-collapsible-parent]');
    }

    // Catch mouseleave on [data-collapsible-wrapper]
    if (self.options.closeOnMouseleave) {
      self.$element.on({
        mouseleave: function mouseleave() {
          self.reset();
        }
      });
    }

    // catch navigation link clicks
    $('[data-site-navigation] a').on('click', function (event) {
      // check if click was done on mobile navigation
      if ($.pp.ww < 1100) {
        var elementWasClickedBefore = $(this).data('was-clicked-before');
        if (typeof elementWasClickedBefore === 'undefined') {
          // check if there is children
          var checkForChildren = $(this).parent().find('ol').length;
          console.log(checkForChildren);
          if (checkForChildren > 0) {
            event.preventDefault();
            $(this).data('was-clicked-before', true);
            console.log('I clicked a');
          }
        }
      }
    });
  };

  /**
   * open subnav
   *
   * @return void
   * @access public
   */
  collapsible_plugin.prototype.open = function ($parent) {
    var self = this;

    // Find target
    var $target = $parent.find('> [data-collapsible-target]:first');
    if ($target.length && self.options.jsAnimation) {
      // Animate target open
      var totalHeight = 0;
      $target.children().each(function () {
        totalHeight = totalHeight + $(this).outerHeight(true);
      });
      $target.stop().animate({
        maxHeight: totalHeight
      }, function () {
        // Toggle class on parent
        $parent.addClass('collapsible__is-open');
        $target.css({
          maxHeight: ''
        });
      });
    } else {
      // Toggle class on parent
      $parent.addClass('collapsible__is-open');

      // Close siblings if Window Width >= self.options.closeSiblings
      if (self.options.closeSiblings > 0 && $.pp.ww >= self.options.closeSiblings) {
        $parent.siblings().each(function (index, el) {
          self.close($(this));
        });
      }
    }
  };

  /**
   * close subnav
   *
   * @return void
   * @access public
   */
  collapsible_plugin.prototype.close = function ($parent) {
    var self = this;

    // Find target
    var $target = $parent.find('> [data-collapsible-target]:first');
    if ($target.length && self.options.jsAnimation) {
      // Animate target closed
      var totalHeight = 0;
      $target.children().each(function () {
        totalHeight = totalHeight + $(this).outerHeight(true);
      });
      $target.stop().css({
        maxHeight: totalHeight
      }).animate({
        maxHeight: 0
      }, function () {
        // Toggle class on parent and close all children
        $parent.removeClass('collapsible__is-open').find('.collapsible__is-open').removeClass('collapsible__is-open');
        $target.css({
          maxHeight: ''
        });
      });
    } else {
      // Toggle class on parent and close all children
      $parent.removeClass('collapsible__is-open').find('.collapsible__is-open').removeClass('collapsible__is-open');
    }
  };

  /**
   * reset navigation elements
   *
   * @return void
   * @access public
   */
  collapsible_plugin.prototype.reset = function () {
    var self = this;
    self.$element.find('[data-collapsible-trigger]').each(function (index, el) {
      var $parent = $(this).closest('[data-collapsible-parent]');
      if ($parent.hasClass('collapsible__is-open')) {
        $parent.trigger('collapsibleClose');
      }
    });
  };

  /**
   * collapsible plugin
   *
   * @return jQuery objects
   */
  $.fn.collapsible = function (options) {
    // Put args in array
    var args = Array.prototype.slice.call(arguments, 1);

    // Initialize the items
    return this.each(function () {
      // Store the element the plugin is set on
      var $element = $(this);

      // Guard if plugin was already initted
      var instance = $element.data('plugin_' + _pluginName);

      // If plugin was not innited
      if (!instance) {
        // Init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new collapsible_plugin($element, options));
      } else {
        // If instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };
}(jQuery, document, window);
$.pp.pageInit = function () {
  // Init collapsible panes
  $('[data-collapsible-wrapper]').collapsible();

  // show sidefloat counter
  window.onscroll = function () {
    var scrollTop = $(window).scrollTop();
    if (scrollTop > 500) {
      $("[data-countdown-wrap]").addClass("zp-countdown-sidefloat");
    } else {
      $("[data-countdown-wrap]").removeClass("zp-countdown-sidefloat");
    }
  };

  // countDown timer
  function countDownTimer() {
    if (localStorage.getItem("total_seconds")) {
      var total_seconds = localStorage.getItem("total_seconds");
    } else {
      var total_seconds = 60 * 60 * 24;
    }
    total_seconds = total_seconds - 1;
    var hours = parseInt(total_seconds / 60 / 60);
    var remaining_hours = 24 - hours;
    var minutes = 0;
    if (remaining_hours > 0) {
      var taken_second_count = hours * 3600;
      var remaining_seconds = total_seconds - taken_second_count;
      var minutes = Math.floor(remaining_seconds / 60);
      var taken_minutes = minutes * 60;
      var left_seconds = remaining_seconds - taken_minutes;
      var seconds = left_seconds;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (hours < 10) {
      hours = "0" + hours;
    }
    document.querySelector("[data-holiday-timer]").innerHTML = hours + ":" + minutes + ":" + seconds;
    document.querySelector("[data-holiday-timer-second]").innerHTML = hours + ":" + minutes + ":" + seconds;
    if (total_seconds <= 0) {
      var total_seconds = 60 * 60 * 24;
      localStorage.setItem("total_seconds", total_seconds);
      setTimeout(function () {
        countDownTimer();
      }, 1000);
    } else {
      localStorage.setItem("total_seconds", total_seconds);
      setTimeout(function () {
        countDownTimer();
      }, 1000);
    }
  }
  if (document.querySelector("[data-holiday-timer]") !== null) {
    setTimeout(function () {
      countDownTimer();
    }, 1000);
  }

  // color variant switch
  var colors = document.querySelectorAll('[data-product-color]');
  colors.forEach(function (color) {
    color.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      e.target.closest('.product-colors__wrapper').querySelector('.product-colors__color.product-colors__color--active').classList.remove('product-colors__color--active');
      e.target.classList.add('product-colors__color--active');
      var variantID = e.target.dataset.productColorVariant;
      var currentVariantUrl = e.target.closest('a').getAttribute('href');
      var urlArr = currentVariantUrl.split(':1?');
      var url_part_split = urlArr[0].split('cart/');
      var url_part_1 = url_part_split[0];
      var url_part_2 = urlArr[1];
      var full_url = url_part_1 + 'cart/' + variantID + ':1?' + url_part_2;
      e.target.closest('a').setAttribute('href', full_url);
      var variantColor = e.target.dataset.productColorName;
      e.target.closest('.product-colors').querySelector('span').innerHTML = 'Color: ' + variantColor;
    });
  });

  // ajax loader
  var ajaxLoaders = document.querySelectorAll('[data-ajax-loader]');
  ajaxLoaders.forEach(function (ajaxLoader) {
    ajaxLoader.addEventListener('click', function (e) {
      e.target.closest('.product-grid__product_atc').classList.add('product-grid__product_atc--loader');
    });
  });
};
$.pp.pageInit();

/**
 * shopify Theme editor Events
 */
if ($.pp.themeEditor) {
  $(document).on('shopify:section:load', function (e) {
    $.pp.pageInit();
  });
}